const Webtrekk = {
  install(Vue, { store }) {
    const call = async (cb) => {
      const { initPromise, features, isEnableWebtrekk } = store.state.system;
      if (initPromise instanceof Promise) {
        try {
          await initPromise; // wait until init request is loaded
        } catch (ignore) {
          // The init request failed (e.g. a backend error routes the user to the error
          // page, which itself triggers a webtrekk page view). There is nothing to track
          // in that case, so skip silently instead of letting the rejection escape as an
          // unhandled promise rejection.
          return;
        }
        if (isEnableWebtrekk && features.enableWebtrekkIntegration) {
          const plugin = await import('@/utils/webtrekk'); // only load script if needed
          cb(plugin);
        }
      }
    };

    const viewPageWithPayload = async (pageContentSuffix, payloadObject) => {
      const { tealiumURL } = store.state.system;
      const payload = {
        page_type: null,
        shop_product_sku: null,
        shop_product_status: null,
        shop_product_name: null,
        shop_product_quantity: null,
        shop_product_price: null,
        shop_order_value: null,
        shop_order_id: null,
        ...payloadObject,
      };
      return call(({ view }) => view(this, store, tealiumURL, pageContentSuffix, payload));
    };

    const viewPage = async (pageContentSuffix, pageName) => {
      const payload = {
        page_type: pageName || null,
      };
      return viewPageWithPayload(pageContentSuffix, payload);
    };

    Vue.prototype.$webtrekk = {
      viewPage: viewPage,
      viewPageWithPayload: viewPageWithPayload,
      link: async (buttonText, target) => {
        return call(({ link }) => link(this, store, buttonText, target));
      },
    };
  },
};

export default Webtrekk;
